
import { Component, Vue } from 'vue-property-decorator';

import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';

import PagesModule from '@/store/pages';
import DirectoriesModule from '@/store/directories';
import PageEntityModule from '@/store/pages/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { BackendPage } from '@/store/pages/backend';
import { Maybe } from '@/types/common';

@Component({
    components: {
        Layout,
        ListBlock,
        ConfirmModal,
    },
})
export default class PagesPage extends Vue {
    repository = PagesModule;
    
    pageToDelete: Maybe<BackendPage> = null

    get deleteModal() {
        return Boolean(this.pageToDelete);
    }

    set deleteModal(open: boolean) {
        if (open) {
            return
        }
        
        this.pageToDelete = null;
    }
    
    get deleteConfirmationText() {
        const pageTitle = this.pageToDelete?.title
        if (!pageTitle) {
            return '';
        }

        return `Точно ли хотите удалить страницу "${pageTitle}"?`;
    }

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }

    get currentTab() {
        return DirectoriesModule.allTabs.pages.id;
    }

    toAdd() {
        this.$router.push({ name: 'pages_create' });
    }

    async updateList() {
        await this.repository.getList();
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.getList();
    }

    confirmPageDelete(page: BackendPage) {
        this.pageToDelete = page;
    }

    async deletePage() {
        const pageId = String(this.pageToDelete?.id);

        if (!pageId) {
            return;
        }

        try {
            await PageEntityModule.delete(pageId)

            // TODO: remove page from the state instead of refetching the whole list
            await this.updateList();
            ResponseHandlerModule.showNotify({ message: 'Статическая страница удалена', type: 'ok' });
        } catch (response) {
             const error = response.response.data;

            if (error.message) {
                ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
            }
        }
    }
}
